import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { LiveAgentRunsPage } from "~/pages/LiveAgentRunsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/$id/runs/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id } = Route.useParams();
  useBreadCrumbs([
    { title: "Settings", link: `/${datasetSlug}/settings/api` },
    { title: "Live Agents", link: `/${datasetSlug}/settings/live-agents` },
    { title: "Runs", link: `/${datasetSlug}/settings/live-agents/${id}/runs` },
  ]);
  return <LiveAgentRunsPage liveAgentId={id} />;
}
